import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import boatsetterPaths from 'utils/boatsetterPaths';
import { mediaMSmMax } from 'helpers/breakpoints';

export type ActiveNavOption = 'personal_info' | 'payment_methods' | 'notifications' | 'password';

interface AccountSettingsNavProps {
  active: ActiveNavOption;
  bypassClerk?: boolean;
}

const NavWrapper = styled.div`
  min-width: 210px;
  padding-right: 32px;
  border-right: 1px solid #dbdfe5;

  ${mediaMSmMax} {
    display: none;
  }

  .navItem {
    padding-bottom: 32px;
    display: flex;
    align-items: center;

    img {
      margin: auto 16px auto 0;
    }

    a {
      margin: auto 0;
      font-weight: 500;
      font-size: 14px;
      color: #001d58;
      text-decoration: none;
    }

    &.active {
      opacity: 0.3;
    }
  }
`;

const AccountSettingsNav: React.FC<AccountSettingsNavProps> = ({ active, bypassClerk = false }) => {
  const passwordPath = `${boatsetterPaths.account}/${bypassClerk ? 'password/edit' : 'change-password'}`;

  return (
    <NavWrapper>
      <div className={`navItem ${active === 'personal_info' ? 'active' : ''}`}>
        <img width={15} height={15} src="/images/icons/user.svg" alt="User" />
        <Link href={`${boatsetterPaths.account}/personal_information`}>Personal information</Link>
      </div>
      <div className={`navItem ${active === 'payment_methods' ? 'active' : ''}`}>
        <img width={15} height={15} src="/images/icons/credit-card.svg" alt="Payment" />
        <Link href={`${boatsetterPaths.account}/payment_methods`}>Payment methods</Link>
      </div>
      <div className={`navItem ${active === 'notifications' ? 'active' : ''}`}>
        <img width={15} height={15} src="/images/icons/alert.svg" alt="Alerts" />
        <Link href={`${boatsetterPaths.account}/notifications`}>Notification settings</Link>
      </div>
      <div className={`navItem ${active === 'password' ? 'active' : ''}`}>
        <img width={15} height={15} src="/images/icons/lock.svg" alt="Lock" />
        <Link href={passwordPath}>Change password</Link>
      </div>
    </NavWrapper>
  );
};

export default AccountSettingsNav;
